export const DEFAULT_CHART_CONFIG: LiveWidgetConfig = {
    integration: 'teste',
    hideTimestamp: false,
    hideLatlng: false
}

export const MAX_LATLNG = 100
export const URL_KEY = 'latLngs'
